import { render } from "./pickers.vue?vue&type=template&id=1ca6516e"
import script from "./pickers.vue?vue&type=script&lang=js"
export * from "./pickers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__